import React from "react";

import { Table, Typography } from "antd";
import { displayDate } from "../../../core/utils/date";
import { expandFromInvoice } from "./invoiceDetails";

const { Text, Title } = Typography;

const Tasks = (props) => {
    const columns = (props) => [
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
            render: (date) => (date ? displayDate(date) : "-"),
            width: 100,
        },
        { title: "Type", dataIndex: "type", key: "type", width: 150 },
        { title: "Invoice", dataIndex: "number", key: "number" },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            width: 150,
        },
        {
            title: "Price",
            dataIndex: "subtotalValue",
            key: "subtotalValue",
            align: "right",
            width: 200,
            render: (price, record) => (
                <>
                    {price} {record.amountType}
                </>
            ),
        },
    ];

    const invoices = props.invoices;

    if ((invoices || []).length == 0) {
        return null;
    }

    const expandedRowClassName = (record, index, indent) => "table-finance-details";
    const rowExpandable = (record) => true;
    const rowKey = (record) => record.id;

    return (
        <>
            <Table
                size="small"
                className="components-table-demo-nested"
                columns={columns(props)}
                expandable={{
                    expandedRowRender: expandFromInvoice,
                    rowExpandable,
                    expandedRowClassName,
                }}
                rowKey={rowKey}
                dataSource={invoices}
                pagination={false}
                title={() => <Title level={5}>Invoices</Title>}
                summary={() => {
                    return (
                        <>
                            <Table.Summary.Row>
                                <Table.Summary.Cell colSpan={4}></Table.Summary.Cell>
                                <Table.Summary.Cell align="right" colSpan={1}>
                                    <Text strong>Total</Text>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell align="right">
                                    <Text strong>
                                        {props.job.balanceClient} {props.job.totalToReceiveType}
                                    </Text>
                                </Table.Summary.Cell>
                            </Table.Summary.Row>
                        </>
                    );
                }}
            />
        </>
    );
};

export default Tasks;
